import React from 'react';

import PurlForm from '../PurlForm';

const PurlEditForm = (props) => <PurlForm {...props} isEditMode />;

export default PurlEditForm;
